import { IncentiveActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { IncentiveFormData } from 'src/screens/General/screens/Incentives/components/IncentiveForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface UpdateIncentiveAction {
    type: typeof IncentiveActions.UPDATE_INCENTIVE;
    payload: {
        data: Partial<IncentiveFormData>;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function updateIncentive(
    data: Partial<IncentiveFormData>,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): UpdateIncentiveAction {
    return {
        type: IncentiveActions.UPDATE_INCENTIVE,
        payload: {
            data,
            onSuccess,
            onError,
        },
    };
}

export interface GetIncentivesAction {
    type: typeof IncentiveActions.FETCH_INCENTIVES;
    payload: QueryParams;
}

export function getIncentives(params: QueryParams): GetIncentivesAction {
    return {
        type: IncentiveActions.FETCH_INCENTIVES,
        payload: params,
    };
}
export function getIncentivesCsv(params: QueryParams): GetIncentivesAction {
    return {
        type: IncentiveActions.FETCH_INCENTIVES_CSV,
        payload: params,
    };
}

export function getIncentivesInFile(params: QueryParams): GetIncentivesAction {
    return {
        type: IncentiveActions.FETCH_INCENTIVES_IN_FILE,
        payload: params,
    };
}

export interface GetIncentivesEntitiesAction {
    type: typeof IncentiveActions.FETCH_INCENTIVES_ENTITIES;
    payload: { id: string | number; caseEnt: string };
}

export function getIncentivesEntities(params: { id: string | number; caseEnt: string }): GetIncentivesEntitiesAction {
    return {
        type: IncentiveActions.FETCH_INCENTIVES_ENTITIES,
        payload: params,
    };
}

export interface GetProvidersIncentivesAction {
    type: typeof IncentiveActions.FETCH_INCENTIVES_PROVIDERS;
    payload: { dateFrom: string; dateTo: string };
}

export function getProvidersIncentive(payload: { dateFrom: string; dateTo: string }): GetProvidersIncentivesAction {
    return {
        type: IncentiveActions.FETCH_INCENTIVES_PROVIDERS,
        payload,
    };
}
export interface GetIncentiveAction {
    type: typeof IncentiveActions.FETCH_INCENTIVE;
    payload: {
        id: string | number;
    };
}

export function getIncentive(id: string | number): GetIncentiveAction {
    return {
        type: IncentiveActions.FETCH_INCENTIVE,
        payload: { id },
    };
}

export interface DeleteIncentiveAction {
    type: typeof IncentiveActions.DELETE_INCENTIVE;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteIncentive(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteIncentiveAction {
    return {
        type: IncentiveActions.DELETE_INCENTIVE,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistIncentiveAction {
    type: typeof IncentiveActions.PERSIST_INCENTIVE;
    payload: {
        data: IncentiveFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIncentive(data: IncentiveFormData, callbacks: SagaPromise<any>): PersistIncentiveAction {
    return {
        type: IncentiveActions.PERSIST_INCENTIVE,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIncentive = (data: IncentiveFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIncentive(data, { resolve, reject }));
    });
};

export type Actions =
    | GetIncentivesAction
    | GetIncentiveAction
    | DeleteIncentiveAction
    | PersistIncentiveAction
    | GetProvidersIncentivesAction
    | UpdateIncentiveAction
    | GetIncentivesEntitiesAction;
